import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import AutoCompleteComponent from '#app/Component/AutoCompleteComponent';
import ButtonComponent from '#app/Component/ButtonComponent';
import SelectComponent from '#app/Component/SelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/InventoryManagement/Deposit/Picking';
import useAutocompleteByProduct from '#app/hooks/useAutocompleteByProduct';
import useDeposits from '#app/hooks/useDeposit';

type Props = {
  handleSearch: (data: Filters) => void;
  filters: Filters;
};

const Search: React.FC<Props> = ({ handleSearch, filters }) => {
  const classes = useStyles();
  const { deposits } = useDeposits(true);
  const { byProducts, debouncedChange } = useAutocompleteByProduct();

  const [formSearch, setFormSearch] = useState<Form>({
    deposit: {
      name: 'deposit',
      label: 'Dépot',
      textHelper: 'Rechercher par dépots.',
      type: 'integer',
      options: { validation: ['required'] },
      defaultValue: filters.deposit,
    },
    byProduct: {
      name: 'byProduct',
      label: 'Article',
      textHelper: "Rechercher par nom d'article.",
      type: 'integer',
      defaultValue: filters.byProduct,
    },
    pickingLocation: {
      name: 'pickingLocation',
      label: 'Emplacement de Picking',
      textHelper: 'Rechercher par picking.',
      type: 'text',
      defaultValue: filters.pickingLocation,
    },
  });

  const handlerForm = initFormHandler(formSearch, setFormSearch);

  useEffect(() => {
    handlerForm.start();
  }, []);

  const getData = (): Filters => {
    const data = handlerForm.getData();

    return {
      deposit: data.deposit,
      byProduct: data.byProduct,
      pickingLocation: data.pickingLocation,
      storage: data.storage,
    };
  };

  return (
    <ShadowBoxComponent>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
          <SelectComponent id="deposit" options={deposits} handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <AutoCompleteComponent
            id="byProduct"
            handler={handlerForm}
            loadOptions={(value, callback) => {
              debouncedChange(value);
              callback(byProducts);
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="pickingLocation" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <ButtonComponent
            className={classes.button}
            label="Rechercher"
            onClick={() => handlerForm.checkError() < 1 && handleSearch(getData())}
          />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  button: {
    margin: '6px !important',
  },
});

export default Search;
